// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/scss/about.scss
// module id = 387
// module chunks = 2